import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ExportDropdown } from '@/common/components/ExportDropdown';
import { Spinner } from '@/common/components/Spinner';
import { useGetExport } from '@/common/hooks/useExport';
import { useToast } from '@/common/hooks/useToast';
import { queryClient } from '@/config/queryClient';
import { useExportDebitNote } from '@/modules/invoicing/hooks/useExportDebitNote';
import { useSelectedDebitNote } from '@/modules/invoicing/hooks/useSelectedDebitNote';

import { TableHead } from './components/TableHead';
import { TableRow } from './components/TableRow';
import * as style from './styles';

export function ChassisTable() {
  const { selectedDebitNote } = useSelectedDebitNote();
  const [exportOption, setExportOption] = useState<string | null>(null);
  const { toast } = useToast();
  const { exportFile } = useGetExport();
  const { t } = useTranslation('invoicing/batchInvoices');

  const { exportDebitNoteData, isExporting, isErrorExporting } =
    useExportDebitNote(selectedDebitNote?.id || '', exportOption);

  useEffect(() => {
    if (!exportDebitNoteData) return;
    exportFile(exportDebitNoteData);
    queryClient.invalidateQueries(['getExportDebitNote']);
    setExportOption(null);
  }, [exportDebitNoteData, exportFile]);

  useEffect(() => {
    if (isErrorExporting) {
      toast.error(
        t('errorExportDebitNoteData'),
        isErrorExporting?.response?.data?.friendlyMessage,
        {
          toastId: 'errorExportDebitNoteData',
        },
      );
    }
  }, [isErrorExporting, toast, t]);

  return (
    <div>
      <table className={style.table()}>
        <TableHead />

        <tbody className={style.tableBody()}>
          {selectedDebitNote?.DebitNoteSignChassisInstallments.map(
            installment => (
              <TableRow key={installment.id} data={installment} />
            ),
          )}
        </tbody>

        <div className="absolute right-[44%] top-[50%]">
          {isExporting && <Spinner size="xl" />}
        </div>
      </table>

      <div className="mx-auto mb-4 mt-auto w-fit">
        <ExportDropdown onExport={setExportOption} defaultValue="xlsx" />
      </div>
    </div>
  );
}
